(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hemvana-welcome"]) return;
  try {
    
  document.querySelectorAll('[data-hv-welcome]').forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('dialog');
    const trigger = root.querySelector('[data-hv-open]');
    let previousFocus;
    const key = 'hemvana-welcome-until';
    const getUntil = () => { try { return Number(localStorage.getItem(key) || 0); } catch { return 0; } };
    const suppress = (days) => { try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch {} };
    const open = () => {
      if (dialog.open) return;
      previousFocus = document.activeElement;
      dialog.showModal();
      trigger.hidden = true;
    };
    const close = () => dialog.close();
    trigger.addEventListener('click', open);
    root.querySelectorAll('[data-hv-close]').forEach((button) => button.addEventListener('click', close));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) { const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close(); } });
    dialog.addEventListener('close', () => { suppress(root.querySelector('[data-hv-success]') ? 365 : 7); trigger.hidden = false; previousFocus?.focus(); });
    if (root.querySelector('[data-hv-success]')) { suppress(365); open(); }
    else if (root.querySelector('[data-hv-errors]')) open();
    else if (root.dataset.editor !== 'true' && getUntil() < Date.now()) {
      window.setTimeout(() => {
        if (document.visibilityState === 'visible' && !document.querySelector('dialog[open], #Details-menu-drawer-container[open]') && document.activeElement?.tagName !== 'INPUT') open();
      }, Number(root.dataset.delay));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
